import React, { Component } from 'react';
import { message, Card } from 'antd';
import { connect } from 'react-redux';
import { queryBusinessInfo } from '@api/common/business';
import AddressFree from './AddressFree';
import AddressPayable from './AddressPayable';
import TableLog from './TableLog';

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataInfo: {},
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.businessInfo();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.params.uuid !== this.props.params.uuid) {
      window.location.reload();
    }
  }

  businessInfo = () => {
    queryBusinessInfo({
      businessUuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataInfo: res.data,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { dataInfo } = this.state;
    const parentProps = {
      ...this.props,
      dataInfo,
      loadDetail: this.businessInfo,
    };
    return (
      <div>
        {dataInfo.price || dataInfo.payables ? (
          <AddressPayable {...parentProps} />
        ) : (
          <AddressFree {...parentProps} />
        )}
        <Card title="操作日志" className="mb16">
          <TableLog dataSource={[]} noOp businessUuid={dataInfo.businessUuid} />
        </Card>
      </div>
    );
  }
}

export default connect(state => ({ organization: state.organization }))(BaseForm);



// WEBPACK FOOTER //
// ./src/components/incubator/contract/detail/PageAddressDetail.js